module.exports = __webpack_public_path__ + "static/media/cow_growth.e41de8ee.png";